import { memo } from 'react';
import './style.scss';
import Skeleton from 'react-loading-skeleton';
import { REFUND_LOG_COLUMN } from '../../constants/refundLogRow';

const RefundLogListRowSkeleton = (): JSX.Element => {
  const skeletonClassName = 'cell-skeleton';

  return (
    <div className="refund-log-list refund-log-skeleton">
      <div className={`cell cell-${REFUND_LOG_COLUMN.DATE}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.AUTHOR}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.BRANCH}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.ORDER_ID}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.AMOUNT}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.STATUS}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.TYPE}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.REASON}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
      <div className={`cell cell-${REFUND_LOG_COLUMN.ARN}`}>
        <Skeleton height={16} className={skeletonClassName} />
      </div>
    </div>
  );
};

export default memo(RefundLogListRowSkeleton);
